import { Colors } from '@estee/elc-base-theme';

export const linkWrapperTheme = () => `
    color: ${Colors.black};
    text-decoration: underline;
    &:hover {
        text-decoration: none;
    }
`;

export const ProfileInfoLabelTheme = () => `
    color: ${Colors.primary700};  
`;

export const ProfileInfoTextTheme = () => `
    color: ${Colors.primary900};
`;

export const ProductNotifyMePopupNoticeTheme = () => `
    background: ${Colors.white};
    border: 1px solid ${Colors.primary400};
    border-radius: 3px;
`;
